import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=15112b3b&"
import script from "./MarketPlace.vue?vue&type=script&lang=js&"
export * from "./MarketPlace.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports